import { useRef, useState } from 'react'
import { Overlay, Popover, PopoverContent } from 'react-bootstrap'

import styles from './BasePopover.module.scss'

interface BasePopoverProps {
  id?: string
  className?: string
  component?: React.ElementType
  popoverContent?: React.ReactNode
}

export const BasePopover: React.FC<BasePopoverProps> = ({
  id = '',
  children,
  className,
  component: Component = 'div',
  popoverContent,
}) => {
  const [show, setShow] = useState(false)
  const target = useRef(null)

  return (
    <>
      <Component
        ref={target}
        onClick={() => setShow(!show)}
        onMouseEnter={() => setShow(true)}
        onMouseLeave={() => setShow(false)}
        className={className}
      >
        {children}
      </Component>
      <Overlay target={target.current} show={show} placement="top">
        <Popover id={id} className={styles.popover}>
          <PopoverContent>{popoverContent}</PopoverContent>
        </Popover>
      </Overlay>
    </>
  )
}

export default BasePopover
